import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { NotificationService } from 'src/app/services/notification.service'
import { ActivatedRoute } from '@angular/router'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import {
	IHandlerOperationAndMonitoring,
	IHandlerOperationConfiguration,
	IManagementMonitoring
} from 'src/app/models/HandlerOperation'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'

@Component({
	selector: 'app-management-configuration',
	templateUrl: './management-configuration.component.html'
})
export class ManagementConfigurationComponent implements OnInit, AfterViewInit {

	constructor(
		private operationService: HandlerOperationService,
		public notificationService: NotificationService,
		private activateRoute: ActivatedRoute
	) {}

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective
	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}
	public operations: Array<IHandlerOperationConfiguration> = []
	public monitoring: IManagementMonitoring
	public ViewValidation: ViewValidation = new ViewValidation()
	public loading: boolean = false
	public isAdmin: boolean = false
	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()

	public ngOnInit(): void {

		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))

		this.notificationService.starterLoading.subscribe(
			() => (this.loading = true)
		)
		this.notificationService.stopperLoading.subscribe(
			() => (this.loading = false)
		)

		this.fetchTableResolver()
		this.setupDatatables()
	}

	public fetchTableResolver(): void {
		const configurations: IHandlerOperationAndMonitoring =
			this.activateRoute.snapshot.data.managementConfiguration

		this.operations = configurations.operations
		this.monitoring = configurations.manitoring
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			language: {
				url:
					'//cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json'
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				}
			]
		}
	}

	public async changeCheck(
		id: string,
		attribute: string,
		value: boolean
	): Promise<void> {
		if (!(this.isAdmin || this.sessionUser.assignments.includes('MANAGEMENT_CONFIGURATION_UPDATE'))) return

		const managementConfiguration: any = {
			[attribute]: !value
		}

		const checkEnableOperationsInApp = Boolean(
			attribute === 'appInventor' ||
			attribute === 'appEvaluator' ||
			attribute === 'appOpportunity'
		)

		const checkManagementConfiguration = Boolean(
			attribute === 'preventive' ||
			attribute === 'predictive' ||
			attribute === 'corrective' ||
			attribute === 'intensive'
		)

		if (checkManagementConfiguration && value) return

		this.operations.forEach(operation => {
			if (operation.idMongo === id) {
				if (checkEnableOperationsInApp) {
					operation[attribute] = !value
				}
				if (checkManagementConfiguration) {
					operation.HandlerOperationManagementConfiguration.preventive = false
					operation.HandlerOperationManagementConfiguration.predictive = false
					operation.HandlerOperationManagementConfiguration.corrective = false
					operation.HandlerOperationManagementConfiguration.intensive = false

					operation.HandlerOperationManagementConfiguration[attribute] = !value
				}
			}
		})

		this.ngAfterViewInit()

		const response: any =
			await this.operationService.setManagementConfiguration(id, managementConfiguration).toPromise()

		this.notificationService.notify(response.message, 200)
	}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}
}
